exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.item-row[data-v-794679f4]{display:grid;grid-template-columns:30px auto 100px}.total-row[data-v-794679f4]{display:grid;grid-template-columns:auto 100px}", ""]);

// exports
